import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { Workflow, WorkflowConfig } from '../objects/workflow';
import { WorkflowConfigState } from '../objects/workflowConfigState';

const initialState: WorkflowConfigState = {
    workflow_list: [],
    workflow_list_loading: false,
    workflow_config: null,
    workflow_config_loading: false
};

// ── Reducer functions ───────────────────────────────────────────────────────

const updateWorkflowListReducer = (
    state: WorkflowConfigState,
    action: PayloadAction<Workflow[]>
): WorkflowConfigState => ({ ...state, workflow_list: action.payload });

const updateWorkflowListLoadingReducer = (
    state: WorkflowConfigState,
    action: PayloadAction<boolean>
): WorkflowConfigState => ({ ...state, workflow_list_loading: action.payload });

const updateWorkflowConfigReducer = (
    state: WorkflowConfigState,
    action: PayloadAction<WorkflowConfig | null>
): WorkflowConfigState => ({ ...state, workflow_config: action.payload });

const updateWorkflowConfigLoadingReducer = (
    state: WorkflowConfigState,
    action: PayloadAction<boolean>
): WorkflowConfigState => ({ ...state, workflow_config_loading: action.payload });

/** Met à jour la valeur / l'état d'override d'un slot dans la config courante. */
const updateSlotValueReducer = (
    state: WorkflowConfigState,
    action: PayloadAction<{ slot_id: number; value: string; is_overridden: boolean }>
): WorkflowConfigState => {
    if (!state.workflow_config) {
        return state;
    }
    const config = cloneDeep(state.workflow_config);
    config.nodes.forEach((node) => {
        node.slots.forEach((slot) => {
            if (slot.id === action.payload.slot_id) {
                slot.value = action.payload.value;
                slot.is_overridden = action.payload.is_overridden;
            }
        });
    });
    return { ...state, workflow_config: config };
};

// ── Slice ─────────────────────────────────────────────────────────────────────

export const workflowConfig = createSlice({
    name: 'workflowConfig',
    initialState,
    reducers: {
        updateWorkflowList: updateWorkflowListReducer,
        updateWorkflowListLoading: updateWorkflowListLoadingReducer,
        updateWorkflowConfig: updateWorkflowConfigReducer,
        updateWorkflowConfigLoading: updateWorkflowConfigLoadingReducer,
        updateSlotValue: updateSlotValueReducer
    }
});

export const {
    updateWorkflowList,
    updateWorkflowListLoading,
    updateWorkflowConfig,
    updateWorkflowConfigLoading,
    updateSlotValue
} = workflowConfig.actions;

export default workflowConfig.reducer;
